<template>
  <v-toolbar dark color="grey lighten-5">
    <v-toolbar-title class="font-weight-light card-title">
      {{ name }}
    </v-toolbar-title>
    <v-spacer/>
    <v-icon color="primary"
            @click="$router.push({name:'Tools'})">
      mdi-close
    </v-icon>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  name: "Toolbar-Header"
}
</script>

<style scoped>

</style>
